import { motion } from 'framer-motion';
import AnimatedPage from '../components/AnimatedPage';

const PrivacyPolicy = () => {
  return (
    <AnimatedPage>
      <div className="min-h-screen pt-20 pb-12">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="heading-1 mb-6">Privacy Policy</h1>
            <div className="w-20 h-1 bg-black mb-8" />
            <p className="text-gray-600 font-body mb-8">
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div className="space-y-8 font-body">
              <section>
                <h2 className="heading-3 mb-4">Introduction</h2>
                <p className="text-gray-700 leading-relaxed">
                  Welcome to RaiBlog. We respect your privacy and are committed to protecting your personal data. 
                  This privacy policy will inform you about how we look after your personal data when you visit our 
                  website and tell you about your privacy rights.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Information We Collect</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  We may collect, use, store and transfer different kinds of personal data about you:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Identity Data: name, username or similar identifier</li>
                  <li>Contact Data: email address and contact information</li>
                  <li>Technical Data: IP address, browser type and version, device information</li>
                  <li>Usage Data: information about how you use our website and services</li>
                  <li>Marketing and Communications Data: your preferences in receiving marketing from us</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-3 mb-4">How We Use Your Information</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  We use your personal data for the following purposes:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>To provide and maintain our service</li>
                  <li>To notify you about changes to our service</li>
                  <li>To provide customer support</li>
                  <li>To gather analysis or valuable information to improve our service</li>
                  <li>To monitor the usage of our service</li>
                  <li>To detect, prevent and address technical issues</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Cookies and Tracking Technologies</h2>
                <p className="text-gray-700 leading-relaxed">
                  We use cookies and similar tracking technologies to track activity on our website and hold certain 
                  information. Cookies are files with small amounts of data which may include an anonymous unique identifier.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Third-Party Services</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  We may employ third-party companies and individuals to facilitate our service, including:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><strong>Google AdSense:</strong> We use Google AdSense to display advertisements. Google may use cookies 
                  to serve ads based on your prior visits to our website or other websites.</li>
                  <li><strong>Analytics Services:</strong> We may use third-party analytics tools to monitor and analyze 
                  website traffic.</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Data Security</h2>
                <p className="text-gray-700 leading-relaxed">
                  The security of your data is important to us. We strive to use commercially acceptable means to protect 
                  your personal data, but remember that no method of transmission over the Internet or method of electronic 
                  storage is 100% secure.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Your Data Protection Rights</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  You have the following data protection rights:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>The right to access – You have the right to request copies of your personal data</li>
                  <li>The right to rectification – You have the right to request correction of inaccurate data</li>
                  <li>The right to erasure – You have the right to request deletion of your personal data</li>
                  <li>The right to restrict processing – You have the right to request restriction of processing</li>
                  <li>The right to data portability – You have the right to request transfer of your data</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Children's Privacy</h2>
                <p className="text-gray-700 leading-relaxed">
                  Our service does not address anyone under the age of 13. We do not knowingly collect personally 
                  identifiable information from children under 13.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Changes to This Privacy Policy</h2>
                <p className="text-gray-700 leading-relaxed">
                  We may update our Privacy Policy from time to time. We will notify you of any changes by posting 
                  the new Privacy Policy on this page and updating the "Last updated" date.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Contact Us</h2>
                <p className="text-gray-700 leading-relaxed">
                  If you have any questions about this Privacy Policy, please contact us through our{' '}
                  <a href="/contact" className="text-black underline hover:no-underline">Contact page</a>.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </div>
    </AnimatedPage>
  );
};

export default PrivacyPolicy;
